import { render, staticRenderFns } from "./OrderSplitDialog.vue?vue&type=template&id=47813a83&scoped=true&"
import script from "./OrderSplitDialog.vue?vue&type=script&lang=js&"
export * from "./OrderSplitDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderSplitDialog.vue?vue&type=style&index=0&id=47813a83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47813a83",
  null
  
)

export default component.exports